import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductCard.css';

const ProductCard = ({ id, title, image, description, badge, index = 0, comingSoon = false }) => {
    const navigate = useNavigate();
    const cardRef = useRef(null);

    const handleViewDetails = (e) => {
        if (comingSoon) {
            e.preventDefault();
            return;
        }
        navigate(`/product/${id}`);
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-fade-in-up');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1 }
        );

        const currentCard = cardRef.current;
        if (currentCard) {
            observer.observe(currentCard);
        }

        return () => {
            if (currentCard) {
                observer.unobserve(currentCard);
            }
        };
    }, []);

    return (
        <div
            ref={cardRef}
            className={`product-card ${comingSoon ? 'is-coming-soon' : ''}`}
            style={{
                opacity: 0,
                animationDelay: `${index * 0.15}s`
            }}
        >
            <div className="product-image-wrapper" onClick={handleViewDetails} style={{ cursor: comingSoon ? 'default' : 'pointer' }}>
                <img src={image} alt={title} className="product-image" />
                {badge && <span className={`badge product-badge ${badge.type}`}>{badge.text}</span>}
            </div>
            <div className="product-card-content">
                <h3 className="product-title">{title}</h3>
                <p className="product-description">{description}</p>
                <button 
                    className={`btn ${comingSoon ? 'btn-disabled' : 'btn-outline'} product-btn`} 
                    onClick={handleViewDetails}
                    disabled={comingSoon}
                >
                    {comingSoon ? 'Coming Soon' : 'View Details'}
                </button>
            </div>
        </div>
    );
};

export default ProductCard;
